import { Textarea } from '@/components/ui/textarea'
import type { InputProps } from '../input-props'

export function TextareaInput({ field, value, onChange, onBlur, disabled, invalid }: InputProps) {
  const rows = (field.type_config?.rows_hint as number | undefined) ?? 3
  return (
    <Textarea
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      rows={rows}
      aria-invalid={invalid || undefined}
      dir="auto"
    />
  )
}
